// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "src_password_quality_ts") return "" + chunkId + ".js";
	// return url for filenames based on template
	return "" + chunkId + ".js";
};